export default async ({ editorSdkProxy, datasetRef }) => {
  await editorSdkProxy.controllers.setState({
    state: { removableController: [datasetRef] },
  })
  return editorSdkProxy.components.remove({ componentRef: datasetRef })
}
